import styled from "styled-components";
import {OnboardingDialogStepIndicatorDefaultBox} from "./onboarding-dialog-step-indicator.default.box";

export const OnboardingDialogStepIndicatorMrGreenBox = styled(OnboardingDialogStepIndicatorDefaultBox)`
    background-color: ${({theme}) => theme.colors.brandPrimaryLight};
`;